import React, { useCallback, useMemo } from "react";
import cn from "classnames";
// import { matches } from "z";
import ContentEditable from "react-contenteditable";
const MyRecursive = ({
  title,
  id,
  babies,
  tag,
  customHtmlAvailable,
  childrenLess,
  allTreeAttritbutes,
  onClickHandler,
}) => {
  babies = babies || [];
  const activeClasses = allTreeAttritbutes[id]?.classes ?? [];
  customHtmlAvailable = !!customHtmlAvailable;
  if (!!customHtmlAvailable) {
    const customHtml = allTreeAttritbutes[id]?.customHtml ?? "";

    return (
      <ContentEditable
        html={customHtml || "CUSTOM HTML"}
        disabled={true}
        onClick={onClickHandler && onClickHandler(id)}
        className={cn(
          {
            "border-4 p-8 font-semibold text-gray-500 text-center uppercase border-dotted": !customHtml,
          },
          activeClasses
        )}
      />
    );
  }

  const isChildrenAvailable = babies?.length > 0;

  const pattern = [!!childrenLess, !!isChildrenAvailable];

  // const childrenToRender = matches(pattern)(
  //   // (x = [false, true, true]) => (
  //   //   <>
  //   //     {innerText}
  //   //     {babies.map((baby) => (
  //   //       <MyRecursive
  //   //         {...baby}
  //   //         babies={baby.children}
  //   //         key={baby.id}
  //   //         allTreeAttritbutes={allTreeAttritbutes}
  //   //         onClickHandler={onClickHandler}
  //   //       />
  //   //     ))}
  //   //   </>
  //   // ),
  //   // (x = [false, true, false]) => <>{innerText}</>,
  //   (x = [false, true]) =>
  //     babies.map((baby) => (
  //       <MyRecursive
  //         {...baby}
  //         babies={baby.children}
  //         key={baby.id}
  //         allTreeAttritbutes={allTreeAttritbutes}
  //         onClickHandler={onClickHandler}
  //       />
  //     )),
  //   (x = [false, false]) => <>Empty {tag}</>,
  //   (x = true, tail) => null
  // );

  // const isDroppableArea = matches(pattern)(
  //   (x = [false, true]) => false,
  //   (x = [false, false]) => true,
  //   (x = true, tail) => false
  // );

  const childrenToRender = ((conditionArray) => {
    const [x, y] = conditionArray;
    if (x === false && y === true)
      return babies.map((baby) => (
        <MyRecursive
          {...baby}
          babies={baby.children}
          key={baby.id}
          allTreeAttritbutes={allTreeAttritbutes}
          onClickHandler={onClickHandler}
        />
      ));

    if (x === false && y === false) return <>Empty {tag}</>;

    if (x === true) return null;
  })(pattern);

  const isDroppableArea = ((conditionArray) => {
    const [x, y] = conditionArray;
    if (x === false && y === true) return false;

    if (x === false && y === false) return true;

    if (x === true) return false;
  })(pattern);

  return (
    <>
      {React.createElement(
        tag,
        {
          className: cn(
            {
              "border-4 p-8 font-semibold text-gray-500 text-center uppercase border-dotted": isDroppableArea,
            },
            activeClasses
          ),

          // contentEditable: innerTextAvailable,
          onClick: onClickHandler && onClickHandler(id),
        },
        childrenToRender
      )}
    </>
  );
};

export default MyRecursive;
